<template>
  <div>
    <div class="homeAwayData"  style="width: 1200px;">
      <div class="headertop u-flex u-flex-items-center u-flex-between">
        <div class="homeName u-flex u-flex-center u-flex-items-center">
          <img style="margin-right: 4px;" :src="info.homeTeam.customLogo?info.homeTeam.customLogo:'/static/scope/defaultqiu.png'" alt="">
          {{info.homeTeam.nameCn}}
        </div>
        <div class="scoreNums">
          <span>{{info.matchData.homeScore}}</span>
          :
          <span>{{info.matchData.awayScore}}</span>
        </div>
        <div class="homeName u-flex u-flex-center u-flex-items-center">
          {{info.awayTeam.nameCn}}
          <img  style="margin-left: 4px;"  :src="info.awayTeam.customLogo?info.awayTeam.customLogo:'/static/scope/defaultqiu.png'" alt="">
        </div>
      </div>
      <!-- 比分 -->
      <div class="u-flex headerBotter" >
        <div class="homeInfoitem" style="border-right: 1px solid #DADADA;">
          <div class="u-flex">
            <div class="homepai">
              <img src="/static/scope/state/0.png" alt="">
              {{copyInfo.matchData.homeCornerNum}}
            </div>
            <div class="homepai">
              <img src="/static/scope/state/3.png" alt="">
              {{copyInfo.matchData.homeYellowNum}}
            </div>
            <div class="homepai">
              <img src="/static/scope/state/2.png" alt="">
              {{copyInfo.matchData.homeRedNum}}
            </div>
          </div>
          <div style="margin-top: 24px;">
            <div class="progressVal">
              <span>射正</span>
              <div class="progress" >
                <el-progress :format='progressdata' color="#721EDC" :percentage="TotalInner.homeup &&TotalInner.homeup.home?TotalInner.homeup.home:50"></el-progress>
              </div>
              <span>{{TotalInner.homeup && TotalInner.homeup.homeValue?TotalInner.homeup.homeValue:0}}</span>
            </div>
            <div class="progressVal">
              <span>射偏</span>
              <div class="progress" >
                 <el-progress   :format='progressdata' color="#721EDC" :percentage="TotalInner.homedown && TotalInner.homedown.home?TotalInner.homedown.home:50"></el-progress>
              </div>
              <span>{{TotalInner.homedown && TotalInner.homedown.homeValue?TotalInner.homedown.homeValue:0}}</span>
            </div>
          </div>
        </div>
        <div class="u-flex headercenter" >
          <div class="circle" >
            <span>
              {{TotalInner.hometo?TotalInner.hometo.homeValue:0}}
            </span>
            <el-progress :width='80' :format='circleValue1' :stroke-width='8' color="#EBEEF5" type="circle" :percentage="TotalInner.hometo?TotalInner.hometo.away:50"></el-progress>
            <span>
             {{TotalInner.hometo?TotalInner.hometo.awayValue:0}}
            </span>
          </div>


          <div class="circle" >
            <span>
              {{TotalInner.homedange?TotalInner.homedange.homeValue:0}}
            </span>
            <el-progress :width='80'  :format='circleValue2' :stroke-width='8'  color="#EBEEF5" type="circle" :percentage="TotalInner.homedange?TotalInner.homedange.away:50"></el-progress>
            <span>
             {{TotalInner.homedange?TotalInner.homedange.awayValue:0}}
            </span>
          </div>
           <div class="circle" >
            <span>
              {{TotalInner.homectrl?TotalInner.homectrl.homeValue:0}}
            </span>
            <el-progress :width='80'  :format='circleValue3' :stroke-width='8'  color="#EBEEF5" type="circle" :percentage=" TotalInner.homectrl?TotalInner.homectrl.away:50"></el-progress>
            <span>
             {{TotalInner.homectrl?TotalInner.homectrl.awayValue:0}}
            </span>
          </div>
        </div>
        <div class="homeInfoitem" style="border-left: 1px solid #DADADA;">
          <div class="u-flex" >
            <div class="homepai">
              <img src="/static/scope/state/2.png" alt="">
              {{copyInfo.matchData.awayRedNum}}
            </div>

            <div class="homepai">
              <img src="/static/scope/state/3.png" alt="">
              {{copyInfo.matchData.awayYellowNum}}
            </div>
           <div class="homepai">
             <img src="/static/scope/state/0.png" alt="">
             {{copyInfo.matchData.awayCornerNum}}
           </div>
          </div>

          <div class="rightprogress" style="margin-top: 24px;">
            <div class="progressVal " >
              <span>
              {{TotalInner.homeup && TotalInner.homeup.awayValue?TotalInner.homeup.awayValue:0}}</span>
              <el-progress  :width='150'  class="progress"   :format='progressdata' color="#EBEEF5" :percentage="100 - (TotalInner.homeup && TotalInner.homeup.away ?TotalInner.homeup.away:50)"></el-progress>
             <span>射正</span>
            </div>
            <div class="progressVal">
              <span>{{TotalInner.homedown && TotalInner.homedown.awayValue?TotalInner.homedown.awayValue:0}}</span>
               <el-progress  :width='150'  class="progress"   :format='progressdata' color="#EBEEF5" :percentage="100 - (TotalInner.homedown && TotalInner.homedown.away?TotalInner.homedown.away:50)"></el-progress>
               <span>射偏</span>
            </div>
          </div>

        </div>
      </div>
    </div>


    <!-- 赛况、阵容、分析、走势 -->
    <div class="sai_info">
      <el-tabs v-model="activeTabs" @click="handleClick">
          <el-tab-pane label="赛况" name="1"></el-tab-pane>
          <el-tab-pane label="阵容" name="2"></el-tab-pane>
          <el-tab-pane label="分析" name="3"></el-tab-pane>
          <el-tab-pane label="走势" name="4"></el-tab-pane>
        </el-tabs>
    </div>
    <div class="sai_databox">
        <div class="dialog_box" v-if="activeTabs == 1">
          <div class="myheight" v-if="eventInner.length > 0">
            <div class="u-flex u-flex-between" v-for="(item,index) in eventInner" :key="index">
              <!-- 主队事件 -->
              <div  class="u-flex celData u-flex-center" v-if="item.kind == 1">
                <div :class="item.content?'useData':''" class="fristOne" style="text-align: right;">
                {{item.content}}
                    <img v-if="item.type == 1" style="width: 16px;height: 16px;" :src="'/static/scope/'+ item.type +'.png'" alt="">
                    <img v-else style="width: 16px;height: 16px;" :src="'/static/scope/state/'+ item.type +'.png'" alt="">
                </div>
                <div class="centerOne">
                  <span>
                    {{item.happenTime}}
                  </span>
                  <div class="lines">

                  </div>
                </div>
                <div class="fristOne"></div>
              </div>
              <!-- 客队事件 -->
              <div class="u-flex celData u-flex-center" v-if="item.kind == 2">
                <div class="fristOne"></div>
              <div class="centerOne">
                <span>
                  {{item.happenTime}}
                </span>
                <div class="lines">
                </div>
              </div>
                <div class="fristOne" style="text-align: left;"  :class="item.content?'useData':''">
                <img v-if="item.type == 1" style="width: 16px;height: 16px;" :src="'/static/scope/'+ item.type +'.png'" alt="">
                <img v-else style="width: 16px;height: 16px;" :src="'/static/scope/state/'+ item.type +'.png'" alt="">
                {{item.content}}</div>
              </div>
              <!-- 中间事件 -->
                <div class="u-flex celData u-flex-center" v-if="item.kind == 0">
                  <div class="centermsg">
                    {{item.content}}
                  </div>
                </div>
            </div>
          </div>
          <div class="myheight" v-else>
            <div class="noDatas">
              <img src="/static/dataimg/no_data.png" alt="" srcset="">
            </div>
          </div>
          <!-- 图例说明 -->
          <div style="background-color: #fff;" class="explainScopeImg">
              图例说明：
              <div class="itemImg">
                <img src="/static/scope/1.png" alt="" srcset="">
                进球
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/8.png" alt="" srcset="">
                乌龙球
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/0.png" alt="" srcset="">
                角球
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/7.png" alt="" srcset="">
                点球
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/13.png" alt="" srcset="">
                点球未进
              </div>
             <!-- <div class="itemImg">
                <img src="/static/scope/state/100.png" alt="" srcset="">
                队长
              </div> -->
              <div class="itemImg">
                <img src="/static/scope/state/11.png" alt="" srcset="">
                换人
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/2.png" alt="" srcset="">
                红牌
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/3.png" alt="" srcset="">
                黄牌
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/9.png" alt="" srcset="">
                两黄一红
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/14.png" alt="" srcset="">
                VAR
              </div>
          <!--    <div class="itemImg">
                <img src="/static/scope/state/101.png" alt="" srcset="">
                助攻
              </div>
              <div class="itemImg">
                <img src="/static/scope/state/102.png" alt="" srcset="">
                全场最佳
              </div> -->
          </div>
        </div>
        <!-- 阵容· -->
        <div v-if="activeTabs == 2">
            <battle :info = 'info'></battle>
        </div>
        <!-- 分析 -->
        <div  v-if="activeTabs == 3" class="fenxiBox">
           <matchResult :info='info'></matchResult>
        </div>
        <!-- 走势 -->
        <div v-if="activeTabs == 4">
          <trend  ref='Mytrend' :matchId = 'info.matchId'></trend>
        </div>
        <div style="height: 100px;"></div>
    </div>
  </div>
</template>

<script>
  import {matchInnerEvent,teamTechStatistic} from '@/api/scope.js'
  import battle from '@/pages/components/lz_battle.vue'
  import trend from '@/pages/components/lz_trend.vue'
  import matchResult from '@/pages/components/lz_matchResult.vue';

  export default {
    components: {
      battle,
      trend,
      matchResult,
    },
    props: {
      info: {
        // 声明类型
        type: Object,
        //声明是否必需
        require: true,
        // 声明默认值
        default: {}
      }
    },
    watch: {
      info: {
        handler(e) {
          console.log('监听比分变化了吗',e);
          this.copyInfo = JSON.parse(JSON.stringify(e))
        },
        deep: true
      }
    },
    created() {
      console.log('比赛数据', this.info);
      this.initData()
      this.copyInfo  =  JSON.parse(JSON.stringify(this.info)) ;
    },
    data() {
      return {
        activeTabs:'1',
        eventInner:{},
        TotalInner:{},
        copyInfo:{}
      }
    },
    methods: {
      circleValue1(){
        return '进攻'
      },
      circleValue2(){
        return '危险进攻'
      },
      circleValue3(){
        return '控球率'
      },
      sums(val1,val2){
        let total = parseInt(val1)  + parseInt(val2);
        val1 = parseInt(val1)
        if(total == 0){
          return 0
        }
        let nums = parseFloat(val1 / total ).toFixed(2)  * 100;
        // console.log('咋回事',val1,val2,total,nums);
        return parseInt(nums)
      },
      fifTotal(list){
        list.map(item=>{
          if(item.typeKey == 4){  // 射正次数
            let {awayValue,homeValue} = item;
            awayValue =  parseInt(awayValue);
            homeValue =  parseInt(homeValue);
            this.TotalInner.homeup ={
             home:this.sums(homeValue >0?homeValue:0,awayValue>0?awayValue:0),
             away:this.sums(awayValue >0?awayValue:0,homeValue>0?homeValue:0),
             homeValue,
             awayValue,
            }

            // console.log('射正次数', this.TotalInner.homeup , awayValue,homeValue);
          }
          if(item.typeKey ==34){  // 射门不中
            let {awayValue,homeValue} = item;
           awayValue =  parseInt(awayValue);
           homeValue =  parseInt(homeValue);
            this.TotalInner.homedown = {
            home:this.sums(homeValue >0?homeValue:0,awayValue>0?awayValue:0),
            away:this.sums(awayValue >0?awayValue:0,homeValue>0?homeValue:0),
            homeValue,
            awayValue,
            }
            // console.log('射门不中', this.TotalInner.homedown , awayValue,homeValue);
          }
          if(item.typeKey ==43){ // 进攻次数
            let {awayValue,homeValue} = item;
            awayValue =  parseInt(awayValue);
            homeValue =  parseInt(homeValue);
            this.TotalInner.hometo = {
           home:this.sums(homeValue >0?homeValue:0,awayValue>0?awayValue:0),
           away:this.sums(awayValue >0?awayValue:0,homeValue>0?homeValue:0),
           homeValue,
           awayValue,
            }


            console.log('进攻次数', this.TotalInner.hometo , awayValue,homeValue);
          }
          if(item.typeKey ==44){ // 	危险进攻次数
            let {awayValue,homeValue} = item;
           awayValue =  parseInt(awayValue);
           homeValue =  parseInt(homeValue);
            this.TotalInner.homedange = {
             home:this.sums(homeValue >0?homeValue:0,awayValue>0?awayValue:0),
             away:this.sums(awayValue >0?awayValue:0,homeValue>0?homeValue:0),
             homeValue,
             awayValue,
            }
          }
          if(item.typeKey ==14){  // 控球时间(百分比)
            let {awayValue,homeValue} = item
            awayValue =  parseInt(awayValue);
            homeValue =  parseInt(homeValue);
            this.TotalInner.homectrl = {
            home:this.sums(homeValue >0?homeValue:0,awayValue>0?awayValue:0),
            away:this.sums(awayValue >0?awayValue:0,homeValue>0?homeValue:0),
            homeValue,
            awayValue,
            }
          }


          if(item.typeKey ==11){  // 黄牌数
            let {awayValue,homeValue} = item
            awayValue =  parseInt(awayValue);
            homeValue =  parseInt(homeValue);
            this.copyInfo.matchData.homeYellowNum = homeValue; // 黄牌数
            this.copyInfo.matchData.awayYellowNum = awayValue; // 黄牌数

          }


          if(item.typeKey ==13){  // 红牌数
            let {awayValue,homeValue} = item
            awayValue =  parseInt(awayValue);
            homeValue =  parseInt(homeValue);
            this.copyInfo.matchData.homeRedNum = homeValue; // 红牌数
            this.copyInfo.matchData.awayRedNum = awayValue; // 红牌数
          }

          if(item.typeKey == 6){  // 角球次数
            let {awayValue,homeValue} = item
            awayValue =  parseInt(awayValue);
            homeValue =  parseInt(homeValue);

            this.copyInfo.matchData.homeCornerNum = homeValue; // 角球
            this.copyInfo.matchData.awayCornerNum = awayValue; // 客队角球
          }
        })
      },
      // 技术统计添加
      changeEventAdd(val){
        let arr = this.eventInner.reverse();
        this.eventInner = arr.concat(val).reverse();
        console.log('赛况变化3',val,this.eventInner);
      },
      // 技术统计删除
      changeEventDel(val){
        let arr = JSON.parse(JSON.stringify(this.eventInner));
        console.log('赛况变化...',arr);
          val.map(items=>{ //
            this.eventInner.map((item,index)=>{
              if(items === item.eventId){
                this.eventInner.splice(index,1)
                console.log('赛况变化',index);
              }
            })
        })
        console.log('赛况变化3',val, arr,this.eventInner);
      },
      // 走势
      changeTreeds(val,state){
        if(this.activeTabs == 4){
          this.$refs.Mytrend.objectchange(val,state)
        }
      },
      initData(){
        // 球队技术统计
        teamTechStatistic({
          matchId:this.info.matchId
        }).then(res=>{
          if(res.data.code ==200 &&  res.data.data.length > 0){
              this.fifTotal(res.data.data);
          }
          console.log('技术统计', this.TotalInner);
          // 4 射正
          // 34 射偏  43 进攻   44 危险  14
        })
        // 事件统计
        matchInnerEvent({
          matchId:this.info.matchId
        }).then(res=>{
          this.eventInner =res.data.data;
          console.log('事件统计',res);
        })
      },
      handleClick(){
        console.log(this.activeTabs);
      },
      progressdata(val) {
        // console.log('数据', val);
        return ''
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/style/flex.scss';
  .explainScopeImg{
    min-height: 68px;
    line-height: 68px;
    display: flex;
    border-top: 1px solid rgba(0,0,0,.1);
    flex-flow: row wrap;
    align-items: center;
    padding:0 24px 0;
    margin-bottom: 30px;
    box-sizing: border-box;
    background-color: #fff;
    .itemImg{
      margin-right: 2%;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      img{
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
    }
    .itemImg:last-child{
      margin-right: 0 !important;
    }
  }
    ::v-deep .el-progress path:first-child {
      stroke: #721EDC;
    }

    :deep(.el-progress) path:first-child{
            stroke: #721EDC;
    }
    /deep/ .el-progress{
      .el-progress-circle__track{
        border-style: none;
      }
      path:first-child{
              stroke: #721EDC;
      }
    }
  .sai_databox{
    background-color: #fff;
  }

  .sai_info{
    // max-width: 1200px;
    margin-top: 12px;
    background-color: #fff;
    /deep/ .el-tabs__header{
      padding-left: 24px;
    }
  }
  .dialog_box{
    // max-width: 1200px;
    background-color: #fff;
    .myheight{
      padding: 20px;
      box-sizing: border-box;
      .noDatas{
        width: 100%;
        display: flex;
        justify-content: center;
        padding:50px 0;
        img{
          width: 189px;
          height: 238px;
        }
      }
      .eventCenter{
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;
      }
      .celData{
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 12px;
        .centermsg{
          margin-top: 12px;
          border-radius: 22px;
          padding: 8px 21px;
          border: 1px solid #DADADA;
        }
        .useData{
          border: 1px solid #DADADA;
          background: #FFFFFF;

        }
        .fristOne{
          margin:12px 0;
          width: 365px;
          // min-height:44px;
          border-radius: 9px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          padding: 12px 9px;
          img{
            margin:0 3px;
            vertical-align:middle;
          }
        }
        .centerOne{
          text-align: center;
          font-size: 12px;
          width:40px;
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #999999;
          span:nth-child(1){
            height:16px;
            margin: 4px 0;
          }
         .lines{
            flex: 2;
            height: 100%;
            display: flex;
            width: 1px;
            border-left: 1px dashed #999;
          }
        }

      }
    }
  }
  .homeAwayData {
    // max-width: 1200px;
    background-color: #fff;
    .headercenter {
      // width: 556px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 10px;
      box-sizing: border-box;

      .circle {
        height: 80px;
        display: flex;
        align-items: center;
        span{
          margin: 0 16px;
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
      }
    }

    .headerBotter {
      border-top: 1px solid #DADADA;
      width: 100%;
          display: flex;
      justify-content: space-between;
      .homeInfoitem {
        padding: 24px;
        // width: 321px;
        // flex: 2;
        box-sizing: border-box;
        .rightprogress{
          /deep/  .el-progress-bar__outer{
            background-color: #721EDC !important;
            border-radius: 2% !important;
          }
        }
        /deep/ .el-progress-bar__inner{
              border-radius: 0 !important;
        }
        .progressVal {
          display: flex;
          width: 222px;
          margin-top: 12px;
          span:first-child{
            text-align: center;
            min-width: 17px;
          }
          span {
            margin-right: 6px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .progress {
            width: 157px;
            height: 8px;
            border-radius: 4px;


            /deep/ .el-progress-bar{
              padding-right: 10px !important;
            }
          }
        }

        .homepai {
          margin-right: 24px;
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;

          img {
            margin-right: 8px;
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .headertop {
      height: 90px;
      padding: 0 25px;
      box-sizing: border-box;

      .homeName {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;

        img {
          width: 35px;
          height: 35px;
        }
      }

      .scoreNums {
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;

        span {
          display: inline-block;
          text-align: center;
          padding: 4px;
          width: 26px;
          height: 40px;
          background: #DADADA;
          border-radius: 2px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/components/lz_scoreInfo.vue